<app-slider
  #slider
  [isFavouritesSlider]="true"
  [renderWithZeroItems]="true"
  [items]="records"
  [title]="'user.favorites.title' | translate"
  [preview]="true"
  [featured]="true"
  [placeholder]="loading"
  [showActions]="true"
  [showSubheader]="true"
  [indentTop]="false"
  [showEmptyBoard]="showEmptyBoard"
  [extraHeaderMargin]="false"
  [loadedView]="'USER_LISTS'"
  [collection]="{ id: -1 }"
  (titleClicked)="goToFavourites()">
  <ng-template appSliderActions>
    <div class="actions-wrapper">
      <button mat-flat-button class="only-icon hide-tablet" (click)="goToFavourites()">
        <span class="odilo-icon">navigate_next</span>
      </button>
      <button mat-flat-button class="accent transparent hide-mobile" (click)="goToFavourites()">
        {{ 'common.viewMore' | translate }}
      </button>
      <button
        mat-flat-button
        class="only-icon"
        [matMenuTriggerFor]="actionsMenu"
        [attr.aria-label]="'common.viewMore' | translate">
        <span class="odilo-icon">more_vertical</span>
      </button>
      <mat-menu #actionsMenu="matMenu">
        <button mat-menu-item (click)="addTitles()">
          <span class="odilo-icon">add</span>
          {{ 'lists.addTitles' | translate }}
        </button>
        <button *ngIf="!showEmptyBoard" mat-menu-item (click)="showDeleteAllFavoritesDialog.set(true)">
          <span class="odilo-icon">delete</span>
          {{ 'common.deleteAll' | translate }}
        </button>
      </mat-menu>
    </div>
  </ng-template>

  <ng-template appSliderSubheader>
    <span class="items">
      {{ paginatedFavorites?.itemsTotal }} {{ (paginatedFavorites?.itemsTotal === 1 ? 'common.item' : 'common.items') | translate }}
    </span>
  </ng-template>
</app-slider>

<opac-no-results-cta *ngIf="showEmptyBoard">
  {{ 'lists.noFavorites' | translate }}
  <opac-button type="secondary" (click)="addTitles()">
    {{ 'lists.addElements' | translate }}
  </opac-button>
</opac-no-results-cta>

<opac-confirmation-dialog
  [acceptLabel]="'common.accept'"
  [open]="showDeleteAllFavoritesDialog()"
  [title]="'common.deleteAll' | translate"
  (accept)="removeAllFavorites()"
  (cancel)="showDeleteAllFavoritesDialog.set(false)">
  <p>{{'messages.favorites.confirmRemoveAll' | translate}}</p>
</opac-confirmation-dialog>